import Button from "components/components/Button/Button";
import styled from "styled-components";
import colours from "styles/colours";

export const StyledFooter = styled.footer`
  background-color: ${colours.elexonBlue};
`;

export const FooterContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const FooterTitle = styled.h2`
  color: ${colours.white};
  font-size: 1.5rem;
`;

export const FooterSubtitle = styled.p`
  color: ${colours.white};
  margin-bottom: 1.5rem;
`;

export const StyledButton = styled(Button)`
  :focus-visible {
    border: 1px solid transparent;
  }
`;

export const Copyright = styled.div`
  display: flex;
  align-items: flex-end;
  color: ${colours.white};
`;
